var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./notification-list-header.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e8a139d8\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notification-list-header.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/notification/notification-list-header/notification-list-header.vue.html
// module id = /EXb
// module chunks = 2